import { render, staticRenderFns } from "./risefanssuccess.vue?vue&type=template&id=6b3de5d9&scoped=true"
import script from "./risefanssuccess.vue?vue&type=script&lang=js"
export * from "./risefanssuccess.vue?vue&type=script&lang=js"
import style0 from "./risefanssuccess.vue?vue&type=style&index=0&id=6b3de5d9&prod&lang=less&scoped=true"
import style1 from "./risefanssuccess.vue?vue&type=style&index=1&id=6b3de5d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3de5d9",
  null
  
)

export default component.exports